// Sport picker options (defaults/rules come from the API: tournament.rules / division.rules).
export const SPORT_OPTIONS = [
  ["softball", "Softball"], ["baseball", "Baseball"], ["basketball", "Basketball"], ["volleyball", "Volleyball"],
  ["soccer", "Soccer"], ["flag_football", "Flag Football"], ["football", "Football"], ["kickball", "Kickball"],
  ["pickleball", "Pickleball"], ["cornhole", "Cornhole"], ["hockey", "Hockey"], ["lacrosse", "Lacrosse"],
  ["other", "Other"],
];
export const sportLabel = (key, custom) =>
  key === "other" && custom ? custom : (SPORT_OPTIONS.find(([k]) => k === key) || [, key])[1];
